import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n/i18n'; // Import i18n configuration
import App from './App';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
